import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import ConfirmBtn from "../../components/Button/ConfirmBtn";
import LineBtn from "../../components/Button/LineBtn";
import Flex from "../../components/DefaultStyles/Flex";
import LineBox from "../../components/DefaultStyles/LineBox";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import DropDown, { OptionType } from "../../components/Filters/DropDown";
import Search from "../../components/Filters/Search";
import {
  ChatSection,
  ChatSectionTitle,
} from "../../components/pages/Party/ChatInfo/ChatSearch/ChatSearchResult";
import { PartyInfoFilterContainer } from "../../components/pages/Party/PartyInfo/PartyInfoFilter";
import Pagination from "../../components/Table/Pagination";
import Table from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import AlimTalkModal from "../../components/pages/AlimTalk/AlimTalkModal";
import AlimTalkFilter from "../../components/pages/AlimTalk/AlimTalkFilter";
import Loader from "../../components/DefaultStyles/Loader";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import { useRecoilState, useRecoilValue } from "recoil";
import { atom } from "recoil";
import { authType } from "../Login";
import alimtalkAPIStateCode from "../../assets/alimtalk/APIErrorCode.pdf";
import AlimTalkTableData from "../../components/pages/AlimTalk/AlimTalkTableData";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import { TotalCount } from "../Users/UserInfo";
import { getThousandComma } from "../../Api/ApiCommon";

export interface IAlimTalk {
  id: string;
  messageid: string;
  name: string;
  nickname: string;
  phone: string;
  status: string;
  template: string;
  time: string;
  uid: string;
  sender: string;
  sms_status?: string;
  partyid?: number;
  servsubsid?: number;
}

export const alimTalkPageState = atom<number>({
  key: "alimTalkPageState",
  default: 0,
});

export default function AlimTalk() {
  const auth = useRecoilValue(authType);

  const [savedPage, setSavedPage] = useRecoilState<number>(alimTalkPageState);
  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(0);
  }, []);

  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [sendBtnClick, setSendBtnClick] = useState(false);
  const [filter, setFilter] = useState({
    click: false,
    template: "",
    startDate: "",
    endDate: "",
  });

  const { response, fetchData, loading } = useApi({
    method: "get",
    url:
      `kakao?page=${page}&size=10` +
      (searchValue ? `&${dropDownValue?.value}=${searchValue}` : ``) +
      (filter?.template !== "" ? `&template=${filter?.template}` : ``) +
      (filter?.startDate !== "" ? `&startd=${filter?.startDate}` : ``) +
      (filter?.endDate !== "" ? `&endd=${filter?.endDate}` : ``),
  });

  const tableHead = [
    "UID_이름_닉네임",
    "전화번호",
    "PID",
    "Subscription",
    "템플릿",
    "알림톡",
    "SMS",
    "발송 일시",
    "조회",
  ];

  useEffect(() => {}, [filter]);

  return (
    <>
      <PageTitle title="알림톡 관리" />

      <PartyInfoFilterContainer>
        <Flex gapSize={10}>
          <DropDown
            isDisabled={false}
            setDropDownValue={setDropDownValue}
            dropdownValue={dropDownValue}
            boxWidth={140}
          />

          <Search
            placeholder="입력"
            setSearchValue={setSearchValue}
            isDisabled={dropDownValue ? false : true}
            pageResetEvent={() => setPage(0)}
            inputType={
              dropDownValue?.value === "phone" || dropDownValue?.value === "uid"
                ? "number"
                : undefined
            }
          />
        </Flex>

        <Flex gapSize={10}>
          <LineBtn
            btnText="API 상태 코드"
            icon="file_download"
            btnHeight={38}
            btnClickEvent={() => {
              const link = document.createElement("a");
              link.href = alimtalkAPIStateCode;
              link.setAttribute("download", `카카오 API 상태 코드.pdf`);

              // Append to html link element page
              document.body.appendChild(link);

              // Start download
              link.click();

              // Clean up and remove the link
              document.body.removeChild(link);
            }}
          />
          <ConfirmBtn
            btnText="알림톡 보내기"
            btnColor="mint"
            btnHeight={38}
            btnClickEvent={() => setSendBtnClick(true)}
            isDisabled={!auth?.kakao}
          />
        </Flex>
      </PartyInfoFilterContainer>

      <ChatSection>
        <ChatSectionTitle style={{ marginBottom: 12 }}>
          알림톡 발송 내역
        </ChatSectionTitle>

        <AlimTalkFilter setFilter={setFilter} setPage={setPage} />

        <LineBox>
          <Table tableHeadData={tableHead} tableMinWidth={1085}>
            <>
              {response?.data?.items?.map((d: IAlimTalk) => (
                <AlimTalkTableData d={d} key={d?.id} page={page} onSavePage={() => setSavedPage(page)} />
              ))}
            </>
          </Table>

          <SpaceBetween>
            <Pagination
              totalPage={response?.status === 200 ? response.data.totalPage : 1}
              currentPage={page}
              pageClickEvent={(index) => setPage(index)}
            />

            <TotalCount>
              총{" "}
              {getThousandComma(
                response?.status === 200 ? +response?.data?.totalCount : 0
              )}
              개
            </TotalCount>
          </SpaceBetween>

          <>
            {/* 알림톡 보내기 */}
            {sendBtnClick && (
              <AlimTalkModal
                closeEvent={() => setSendBtnClick(false)}
                confirmEvent={() => {
                  setSendBtnClick(false);
                  fetchData({
                    method: "get",
                    url:
                      `kakao?page=${page}&size=10` +
                      (searchValue
                        ? `&${dropDownValue?.value}=${searchValue}`
                        : ``) +
                      (filter?.template !== ""
                        ? `&template=${filter?.template}`
                        : ``) +
                      (filter?.startDate !== ""
                        ? `&startd=${filter?.startDate}`
                        : ``) +
                      (filter?.endDate !== ""
                        ? `&endd=${filter?.endDate}`
                        : ``),
                  });
                }}
                type="input"
              />
            )}
          </>
        </LineBox>

        <ExcelDownload
          tableHead={tableHead}
          pushedData={(e: any) => {
            return [
              e.messageid,
              `${e.uid}_${e.name}_${e.nickname}`,
              e.phone,
              e.template,
              200 <= Number(e?.status?.split("_")[1]) &&
              Number(e?.status?.split("_")[1]) < 205
                ? "성공"
                : "실패",
              e.status,
              dayjs(e?.time)?.format("YYYY-MM-DD HH:mm"),
            ];
          }}
          dataUrl={
            `kakao?page=0&size=1000` +
            (searchValue ? `&${dropDownValue?.value}=${searchValue}` : ``) +
            (filter?.template !== "" ? `&template=${filter?.template}` : ``) +
            (filter?.startDate !== "" ? `&startd=${filter?.startDate}` : ``) +
            (filter?.endDate !== "" ? `&endd=${filter?.endDate}` : ``)
          }
          disabled={response?.data?.items?.length < 1}
          title="알림톡 발송 내역"
        />

        {loading && <Loader />}
      </ChatSection>
    </>
  );
}
